var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.72 2.66667C4.8 3.85333 5 5.01333 5.32 6.12L3.72 7.72C3.17333 6.12 2.82667 4.42667 2.70667 2.66667H4.72ZM17.8667 18.6933C19 19.0133 20.16 19.2133 21.3333 19.2933V21.28C19.5733 21.16 17.88 20.8133 16.2667 20.28L17.8667 18.6933ZM6 0H1.33333C0.6 0 0 0.6 0 1.33333C0 13.8533 10.1467 24 22.6667 24C23.4 24 24 23.4 24 22.6667V18.0133C24 17.28 23.4 16.68 22.6667 16.68C21.0133 16.68 19.4 16.4133 17.9067 15.92C17.7733 15.8667 17.6267 15.8533 17.4933 15.8533C17.1467 15.8533 16.8133 15.9867 16.5467 16.24L13.6133 19.1733C9.84 17.24 6.74667 14.16 4.82667 10.3867L7.76 7.45333C8.13333 7.08 8.24 6.56 8.09333 6.09333C7.6 4.6 7.33333 3 7.33333 1.33333C7.33333 0.6 6.73333 0 6 0Z","fill":"black","fillOpacity":"0.65"}));
}

Phone.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
